import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { PaymentMethodInfo } from '../../types/generated/Account.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetPaymentMethodQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetPaymentMethodQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, subscription: { __typename?: 'AccountSubscription', id: string, paymentMethod?: { __typename: 'PaymentCard', preferredLocale?: Types.SupportedLocale | null, taxId?: string | null, taxType?: string | null, card?: { __typename?: 'CardInfo', brand: string, expMonth: number, expYear: number, last4: string, name?: string | null } | null, billingAddress?: { __typename?: 'BillingAddress', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null } | null } | { __typename: 'PaymentCheck' } | null } } | null };

export type PaymentMethodSubscriptionFragment = { __typename?: 'Account', id: string, subscription: { __typename?: 'AccountSubscription', id: string, paymentMethod?: { __typename: 'PaymentCard', preferredLocale?: Types.SupportedLocale | null, taxId?: string | null, taxType?: string | null, card?: { __typename?: 'CardInfo', brand: string, expMonth: number, expYear: number, last4: string, name?: string | null } | null, billingAddress?: { __typename?: 'BillingAddress', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null } | null } | { __typename: 'PaymentCheck' } | null } };

export const PaymentMethodSubscription = /*#__PURE__*/ gql`
    fragment PaymentMethodSubscription on Account {
  id
  subscription {
    id
    paymentMethod {
      ...PaymentMethodInfo
    }
  }
}
    ${PaymentMethodInfo}` as unknown as DocumentNode<PaymentMethodSubscriptionFragment, unknown>;
export const GetPaymentMethod = /*#__PURE__*/ gql`
    query GetPaymentMethod($accountId: ID!) {
  account(accountId: $accountId) {
    ...PaymentMethodSubscription
  }
}
    ${PaymentMethodSubscription}` as unknown as DocumentNode<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>;

        

        
export const usePaymentMethodSubscriptionFragment = (
  input: string | Omit<UseFragmentOptions<PaymentMethodSubscriptionFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<PaymentMethodSubscriptionFragment>({
    fragment: PaymentMethodSubscription,
    fragmentName: 'PaymentMethodSubscription',
    ...options,
  });
};
  
        
          

          export const useGetPaymentMethodQuery = (options?:QueryHookOptions<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>) => useQuery(GetPaymentMethod, options);

          

          export type GetPaymentMethodQueryOptions = QueryHookOptions<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>;

          

          export const useGetPaymentMethodLazyQuery = (options?:LazyQueryHookOptions<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>) => useLazyQuery(GetPaymentMethod, options);

          

          export type GetPaymentMethodQueryResult = ReturnType<typeof useGetPaymentMethodQuery>;

          
